<!-- prettier-ignore -->
<div class="skeleton-wrapper">
  @if (type === 'table') {
    <div class="table-container">
      <table class="skeleton-table">
        <caption class="table-description">skeleton-table</caption>
        <thead class="table-head">
          <tr>
            @for (_ of tableCols; track $index; let i = $index) {
              <th [ngClass]="{ 'rounded-tr': i === tableCols.length - 1 }" scope="col">
                <div class="skeleton-box"></div>
              </th>
            }
          </tr>
        </thead>

        <tbody class="table-body">
          @for (_row of tableRows; track $index; let cIdx = $index) {
            <tr>
              @for (_col of tableCols; track $index; let i = $index) {
                <td
                  [ngClass]="{
                    'no-border-bottom': cIdx === tableRows.length - 1,
                    'no-border-right': i === tableCols.length - 1
                  }"
                >
                  <div class="skeleton-box is-centered is-half"></div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>

      <div class="message-overlay">
        <p aria-live="polite">{{ messages }}</p>
      </div>
    </div>
  }

  @if (type === 'alert') {
    <div class="alert-container">
      <app-icon
        height="10rem"
        width="10rem"
        name="alert"
        color="var(--color-gray-300)"
      ></app-icon>

      <div class="alert-message">
        @for (message of messages; track $index; let i = $index) {
          <span [class]="i === 0 ? 'alert-title' : 'alert-text'">
            {{ message }}
          </span>
        }
      </div>
    </div>
  }

  @if (type === 'card') {
    <div class="card" role="status" aria-live="polite">
      <div class="frame">
        <h5 class="title">{{ messages[0] }}</h5>
      </div>
    </div>
  }
</div>
